<template>
    <div class="flex flex-col w-full">
        <label v-if="label" class="font-bold mb-1">
            {{ label }}
        </label>

        <div class="flex">
            <my-select
                v-model="selectedMonth"
                :name="name"
                :error="error ? ' ' : null"
                class="mr-1"
                placeholder="Month"
                :options="months"
            />
            <my-select
                v-model="selectedYear"
                :name="name"
                :error="error ? ' ' : null"
                class="ml-1"
                placeholder="Year"
                :options="years"
            />
        </div>

        <span v-if="error" class="text-xs text-italic text-red-500">
            {{ error }}
        </span>
    </div>
</template>

<script>
import FormInputMixin from './form_inputs_mixin';
import _values from 'lodash/values';

const monthsList = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
];

export default {
    mixins: [FormInputMixin],

    props: {
        afterDate: {
            type: String,
            default: null
        },
        yearsToAdd: {
            type: Number,
            default: null
        }
    },

    data() {
        return {
            months: {},
            years: {},
            selectedMonth: null,
            selectedYear: null
        };
    },

    watch: {
        selectedMonth: function() {
            this.onDateChanged();
        },

        selectedYear: function() {
            this.setMonths();
            this.onDateChanged();
        },

        value: function(newVal) {
            this.parseAndSetDatesFromValue(newVal);
        },

        afterDate: function() {
            this.selectedMonth = null;
            this.selectedYear = null;
            this.setYears();
            this.setMonths();
        }
    },

    created() {
        this.setMonths();
        this.setYears();
        this.parseAndSetDatesFromValue(this.value);
    },

    methods: {
        onDateChanged() {
            if (!this.selectedMonth || !this.selectedYear) {
                this.$emit('input', null);
                return;
            }

            let value = `${this.selectedMonth} ${this.selectedYear}`;

            this.$emit('input', value);
        },

        setMonths() {
            let monthsObj = {};

            let startingMonth = 0;
            let endingMonth = 11;

            let currentDateObj = new Date();

            if (currentDateObj.getFullYear().toString() === this.selectedYear) {
                endingMonth = currentDateObj.getMonth();
            }

            if (this.afterDate) {
                let afterDateObj = new Date('01 ' + this.afterDate);

                if (this.selectedYear === null || afterDateObj.getFullYear().toString() === this.selectedYear) {
                    startingMonth = afterDateObj.getMonth();
                }
            }

            monthsList.forEach((monthName, index) => {
                if (index >= startingMonth && index <= endingMonth) {
                    monthsObj[monthName] = monthName;
                }
            });

            if (this.selectedMonth && !_values(monthsObj).includes(this.selectedMonth)) {
                this.selectedMonth = null;
            }

            this.months = monthsObj;
        },

        setYears() {
            let currentYear = new Date((new Date().getFullYear() + this.yearsToAdd).toString()).getFullYear();
            let yearsObj = {};

            let startingYear = 1950;

            if (this.afterDate) {
                startingYear = new Date('01 ' + this.afterDate).getFullYear();
            }

            for (let year = startingYear; year <= currentYear; year++) {
                yearsObj[year.toString()] = year.toString();
            }

            this.years = yearsObj;
        },

        parseAndSetDatesFromValue(date) {
            if (date === null) {
                this.selectedYear = null;
                this.selectedMonth = null;
                return;
            }

            let dateObj = new Date('01 ' + date);
            this.selectedYear = dateObj.getFullYear().toString();
            this.selectedMonth = monthsList[dateObj.getMonth()];
        }
    }
};
</script>
